import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetName, Text, NotificationLayoutItemProjectName, UserName } from '../../../gql/generated/LayoutItems';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FileUploadedHeader_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type FileUploadedHeader_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type FileUploadedHeader_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type FileUploadedHeader_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type FileUploadedHeader_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type FileUploadedHeader_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type FileUploadedHeader_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type FileUploadedHeader_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> } } };

export type FileUploadedHeader_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type FileUploadedHeader_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type FileUploadedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type FileUploadedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type FileUploadedHeader_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type FileUploadedHeader_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type FileUploadedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type FileUploadedHeader_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type FileUploadedHeader_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type FileUploadedHeaderFragment = FileUploadedHeader_NotificationGroupAccessRequestApproved_Fragment | FileUploadedHeader_NotificationGroupAccessRequestDenied_Fragment | FileUploadedHeader_NotificationGroupAccessRequestSubmitted_Fragment | FileUploadedHeader_NotificationGroupAssetAssignedToYou_Fragment | FileUploadedHeader_NotificationGroupAssetStatusChanged_Fragment | FileUploadedHeader_NotificationGroupCommentCreated_Fragment | FileUploadedHeader_NotificationGroupCommentCreatedShareAccess_Fragment | FileUploadedHeader_NotificationGroupFileUploaded_Fragment | FileUploadedHeader_NotificationGroupReplyCreated_Fragment | FileUploadedHeader_NotificationGroupReplyCreatedShareAccess_Fragment | FileUploadedHeader_NotificationGroupRequesterAccessRequestApproved_Fragment | FileUploadedHeader_NotificationGroupRequesterAccessRequestDenied_Fragment | FileUploadedHeader_NotificationGroupTranscriptCompletedSelf_Fragment | FileUploadedHeader_NotificationGroupTransferBatchCompleted_Fragment | FileUploadedHeader_NotificationGroupTransferBatchCompletedSelf_Fragment | FileUploadedHeader_NotificationGroupUserMentioned_Fragment | FileUploadedHeader_NotificationGroupUserMentionedShareAccess_Fragment;

export type FileUploadedHeaderContentFragment = { __typename?: 'NotificationLayout', header: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } }> };

export const FileUploadedHeaderContent = /*#__PURE__*/ gql`
    fragment FileUploadedHeaderContent on NotificationLayout {
  header {
    ...UserName
    ...Text
  }
}
    ${UserName}
${Text}` as unknown as DocumentNode<FileUploadedHeaderContentFragment, unknown>;
export const FileUploadedHeader = /*#__PURE__*/ gql`
    fragment FileUploadedHeader on NotificationGroup {
  ... on NotificationGroupFileUploaded {
    content {
      layout {
        ...FileUploadedHeaderContent
      }
    }
  }
}
    ${FileUploadedHeaderContent}` as unknown as DocumentNode<FileUploadedHeaderFragment, unknown>;

        

        
export const useFileUploadedHeaderFragment = (
  input: string | Omit<UseFragmentOptions<FileUploadedHeaderFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<FileUploadedHeaderFragment>({
    fragment: FileUploadedHeader,
    fragmentName: 'FileUploadedHeader',
    ...options,
  });
};
  
        
        

        
export const useFileUploadedHeaderContentFragment = (
  input: string | Omit<UseFragmentOptions<FileUploadedHeaderContentFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayout' } };
    return input;
  })();

  return useFragment<FileUploadedHeaderContentFragment>({
    fragment: FileUploadedHeaderContent,
    fragmentName: 'FileUploadedHeaderContent',
    ...options,
  });
};
  
        